export const extractYouTubeId = (url: string): string | null => {
  const regex = /v=([a-z0-9_-]+)/gim;
  const matches = regex.exec(url);

  if (matches === null) return null;

  return matches[1];
};
